import { render, staticRenderFns } from "./ProviderManagement.vue?vue&type=template&id=6e03b4a3&scoped=true"
import script from "./ProviderManagement.vue?vue&type=script&lang=js"
export * from "./ProviderManagement.vue?vue&type=script&lang=js"
import style0 from "./ProviderManagement.vue?vue&type=style&index=0&id=6e03b4a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e03b4a3",
  null
  
)

export default component.exports